"use client";

import styles from "./page.module.css";
import { Modal } from "antd";
import { useCallback } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { AppNav } from "@/app/app-nav";
import AuthPanel from "@/components/auth/AuthPanel";
import { MainDashboard } from "@/components/main/MainDashboard";

export default function HomeNotLogged() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const authOverlayOpen = searchParams.get("auth") == "1";

  const handleCloseAuthOverlay = useCallback(() => {
    const nextParams = new URLSearchParams(searchParams.toString());
    nextParams.delete("auth");
    const query = nextParams.toString();
    const nextPath = query ? `${AppNav.Root}?${query}` : AppNav.Root;
    router.replace(nextPath, { scroll: false });
  }, [router, searchParams]);

  return (
    <>
      <MainDashboard mode="public" />
      <Modal
        open={authOverlayOpen}
        onCancel={handleCloseAuthOverlay}
        footer={null}
        centered
        destroyOnClose
        className={styles.authOverlayModal}
      >
        <AuthPanel embedded />
      </Modal>
    </>
  );
}
